import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Caret from './Caret';
const SplitCaretButton = React.forwardRef((_a, ref) => {
    var { disabled, bsStyle, className } = _a, remainingProps = __rest(_a, ["disabled", "bsStyle", "className"]);
    const splitCaretButtonClasses = classNames('dropdown-toggle', 'btn', `btn-${bsStyle}`, disabled && 'disabled', className);
    return (_jsx("button", Object.assign({}, remainingProps, { role: 'button', type: 'button', className: splitCaretButtonClasses, ref: ref }, { children: _jsx(Caret, {}) })));
});
export default SplitCaretButton;
SplitCaretButton.propTypes = {
    disabled: PropTypes.bool,
    bsStyle: PropTypes.oneOf(['default', 'primary', 'info', 'warning', 'danger', 'success', 'link', 'muted']),
    className: PropTypes.string,
};
